<template>
  <v-main>
    <v-card class="elevation-12 mx-auto mt-1" max-width="500" elevation="0">
      <!-- <v-toolbar color="primary" dark flat>
        <v-toolbar-title class="text-center">Login</v-toolbar-title>
      </v-toolbar> -->
      <p class="text-center red--text text-h5 mt-6">Account</p>
      
      <p class="ma-4 styled-font text-center">Log-in to your account</p>
      <Alert />
      <v-card-text>
        <v-form ref="form" v-model="valid" @keyup.native.enter="submitForm">
          <v-text-field
            label="Email"
            name="login"
            prepend-icon="mdi-email"
            type="email"
            required
            rounded
            dense
            outlined
            v-model="user.email"
            :rules="emailRules"

          />
          <v-text-field
            label="login"
            name="login"
            outlined
            rounded
            dense
            prepend-icon="mdi-lock"
            :type="showPassword ? 'text' : 'password'"
            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
            @click:append="showPassword = !showPassword"
            required
            v-model="user.password"
            :rules="passwordRules"
          />
        </v-form>
      </v-card-text>
      <v-spacer />
      <v-card-actions>
        <v-btn class="buttons white--text text-h5 pa-3" @click="submitForm" rounded large>Login</v-btn>
        <v-spacer />
        <router-link to="forgot_password">Forgot Password?</router-link>
      </v-card-actions>
    </v-card>
    <!-- <v-main>
      <v-container class="fill-height" fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="8" md="5">
            
          </v-col>
        </v-row>
      </v-container>
    </v-main> -->
  </v-main>
</template>

<script>
import Alert from "../templates/Alert"
export default {
  methods: {
    submitForm() {
      if (this.$refs.form.validate()) {
        this.$store.dispatch("userauth/aLoginUser", this.user).then(response => {
          if (response) {
            this.$router.push({ name: "Profiles" });
          }
        });
      }
    }
  },
  components: {
    Alert
  },
  data: () => ({
    valid: true,
    showPassword: false,
    user: {
      email: "",
      password: ""
    },
    emailRules: [
      v => !!v || "E-mail is required",
      v => /.+@.+\..+/.test(v) || "E-mail must be valid"
    ],
    passwordRules: [v => !!v || "Password is required"]
  })
};
</script>

<style lang="scss">
  
</style>
